import {makeQueries, IQueryEnum} from 'core/api';
import AuthStore from 'core/auth';
import {getRetailer, getRetailerId} from 'core/models/retailers/utils';
import {useContext} from 'react';

/** Prefetching data, for better user experience */
function DataPrefetcher() {
  const {isRetailer, isManager, isReturns, isStoreLocatorManager} = useContext(AuthStore);
  const {retailer} = getRetailer();
  const retailerId = getRetailerId();

  /** Common queries */
  makeQueries([
    {type: IQueryEnum.GetProductBrands},
    {type: IQueryEnum.GetRetailers, isEnabled: !isManager && !isReturns},
    {type: IQueryEnum.GetProductCategories, isEnabled: !isManager && !isReturns && !isStoreLocatorManager},
    {type: IQueryEnum.GetProducts, isEnabled: !isManager && !isReturns && !isStoreLocatorManager},
    {type: IQueryEnum.GetSuppliers, isEnabled: !isManager && !isReturns && !isStoreLocatorManager},
    {type: IQueryEnum.GetStates, isEnabled: !isManager && !isReturns && !isStoreLocatorManager},
    {type: IQueryEnum.GetProductItemGroups, isEnabled: !isManager && !isReturns && !isStoreLocatorManager}
  ]);

  /** Admin && Sales queries */
  makeQueries([
    {type: IQueryEnum.GetPriceLists, isEnabled: !isRetailer && !isStoreLocatorManager},
    {type: IQueryEnum.GetProductItems, isEnabled: !isRetailer && !isStoreLocatorManager}
  ]);

  /** Retailer queries */
  makeQueries(
    !isManager && !isReturns && !isStoreLocatorManager
      ? [
          {type: IQueryEnum.GetAddresses, variables: {retailerId}, isEnabled: Boolean(isRetailer)},
          {type: IQueryEnum.GetOrders, variables: {retailerId}, isEnabled: Boolean(isRetailer)},
          {
            type: IQueryEnum.GetProductItems,
            variables: {retailerId},
            isEnabled: Boolean(isRetailer && retailer?.priceListId)
          },
          {
            type: IQueryEnum.GetPriceListItems,
            variables: {retailerId},
            isEnabled: Boolean(isRetailer && retailer?.priceListId)
          }
        ]
      : []
  );

  return null;
}

export default DataPrefetcher;
